// The static splash overlay in index.html (#ano-boot-splash) sits at
// max z-index until React explicitly hides it. AuthGate hides it once
// the main app paints; routes that short-circuit before AuthGate mounts
// (PipedreamDonePage, misconfig fallbacks) must call this themselves or
// they'll render under an opaque "Loading..." screen forever.
const SPLASH_ID = "ano-boot-splash";
const HIDDEN_CLASS = "ano-boot-splash-hidden";
const FADE_MS = 220;

export function hideBootSplash(): void {
  const splash = document.getElementById(SPLASH_ID);
  if (!splash) return;
  splash.classList.add(HIDDEN_CLASS);
  setTimeout(() => splash.remove(), FADE_MS);
}
